<template>
    <Dialog :dialog="dlg">
        <v-form ref="form" lazy-validation>
            <div >
                <Form>
                    <FormRow label="Verstuur naar" col-label="2">                    
                        <TextField :model="model" :rules="model.rules.mandatory" placeholder="Verstuur naar" v-model="model.to"
                            :suggestions="model.recipients" @suggested="handleSuggestionTo" handle-suggestion>                        
                        >                        
                        </TextField>
                    </FormRow>
                    <FormRow label="Onderwerp" col-label="2">                    
                        <TextField :model="model" :rules="model.rules.mandatory" placeholder="Onderwerp" v-model="model.subject"></TextField>
                    </FormRow>
                    <v-row dense>
                        <v-col>
                            <RichTextArea lg :model='model' placeholder='E-mail body' v-model='model.body'>
                                <template v-slot:toolbar-left>
                                    <label class="ml-2 mr-8">Bericht</label>
                                </template>
                            </RichTextArea>
                        </v-col>
                    </v-row>
                </Form>
                <AttachmentSelector disabled no-upload hide-empty-dropdown class="mt-2"
                    :model="model"
                    :prependFixed="model.attachments"
                    :selected="[]"
                    :selectables="[]"
                    @attach="(attachment) =>model.attach(attachment)"
                    @unattach="(attachment) =>model.unattach(attachment)">

                </AttachmentSelector>
            </div>

        </v-form>

    </Dialog>
</template>



<script setup>    
    import Form from '@controls/forms/Form'
    import FormRow from '@controls/forms/FormRow'
    import TextField from '@controls/input/TextField'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import RichTextArea from '@controls/input/RichTextArea'
    import AttachmentSelector from '@/ui/controls/AttachmentSelector'
    import string from '@lib/string'
    import { ref } from 'vue'
    import clsDialog from '@cls/clsDialog'

    import { clsModel } from '@cls/clsModel'
    import {workorders as api} from "@app/api"

    // We operate on a sales invoice, no special model name for sending an invoice. 
    const modelName = "workorder_send";
    const fields = ['id', 'subject', 'body', 'to', 'attachments', 'allattachments', 'recipients'];

    // Such a simple class, keep it inline here for now.
    class clsWorkorderSend extends clsModel {

        subject = null;
        body = null;
        to = null;
        attachments = [];
        allattachments = [];
        recipients = [];

        attach(attachment) {
            this.attachments.push(attachment);
        }
        unattach(attachment) {
            this.attachments = this.attachments.filter( (item) => item != attachment);
        }

    apiLoad(id, params) {
            return this.api.loadSendData(id, params);
        }
        async apiSave(model) {
            return this.api.sendEmail(model);
        }
        /**
         * Override this method to handle default notification or to not notify
         * @param {*} resultData 
         */
        onSaveNotification(resultData, msg) {
            super.onSaveNotification(resultData, "De gegevens zijn verzonden");
        }
        fill(data) {
            data = data || {};
            data.attachments = data.attachments ||[];
            data.allattachments = data.allattachments ||[];
            return super.fill(data);
        }
        
        constructor() {
            super({
            api: api,   
            modelName: modelName, 
            fillable: fields
            })
        }       
    }

    const form = ref(null); 
    let model = ref(new clsWorkorderSend()).value;

    function handleSuggestionTo(v) {
        if ( (model.to||"").indexOf(v) >=0) {
            return;
        }
        model.to = string.concat("; ", model.to, v);
    }

    let dlg = ref(
        new clsDialog("workorder_send", "Stuur werkbon", model, [form], {
            maxWidth: 800,
            icon: 'send',
            noSubTitle: true,
            save: 'Verstuur'
        } )).value;

//    window.wesdlg = dlg;
</script>
